import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { HomePage } from '@/pages/home/ui/HomePage';

const homeSearchSchema = z.object({
  // 初回パスワード設定直後のホーム遷移時にウェルカムモーダルを開かせるためのフラグ。
  // URL からは文字列で渡るため preprocess で boolean に正規化する（z.coerce.boolean は 'false' も true 扱いになるため使えない）
  welcome: z
    .preprocess(
      (val) => (val === 'true' ? true : val === 'false' ? false : val),
      z.boolean().optional(),
    )
    .catch(undefined),
});

export const Route = createFileRoute('/_protected/home')({
  component: HomePage,
  validateSearch: (record) => homeSearchSchema.parse(record),
});
